import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import { mapGetters, mapMutations } from "vuex";
// import { goodsList } from "@/api/data";
export default {
  name: "vipOptions",
  props: {
    value: [String, Array, Number],
    multiple: Boolean,
    readCacheType: Number,
    //不读缓存是1，读缓存是随便只要不等于1就可以
    type: Number
  },
  watch: {
    value: {
      handler: function handler(newVal) {
        this.label = newVal;
      }
    }
  },
  //获取vuex中的状态
  computed: _objectSpread({}, mapGetters("seloptions", ["getSelectOptions", "getMutSelectOptions"])),
  data: function data() {
    return {
      vipLists: [],
      label: this.value,
      prop_selopList: [],
      prop_mutSelList: ""
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.loadServerList();
            _this.readCacheType != 1 ? _this.showSelectOptions() : "";
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations("seloptions", ["setSelectOptions", "setMutSelectOptions"])), {}, {
    //获取选择框下拉列表
    loadServerList: function loadServerList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // let res = await goodsList();
              // if (res.code == 0) {
              //     this.goodsLists = res.data;
              // }
              _this2.vipLists = [{
                vipId: 0,
                vipName: 0
              }, {
                vipId: 1,
                vipName: 1
              }, {
                vipId: 2,
                vipName: 2
              }, {
                vipId: 3,
                vipName: 3
              }, {
                vipId: 4,
                vipName: 4
              }, {
                vipId: 5,
                vipName: 5
              }, {
                vipId: 6,
                vipName: 6
              }];
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //选中的值
    someSelect: function someSelect() {
      //读缓存
      if (this.readCacheType != 1) {
        if (this.multiple === true) {
          //去掉[__ob__: Observer]
          this.setMutSelectOptions(Object.assign([], this.label));
          this.$emit("input", Object.assign([], this.label));
          return 0;
        } else {
          this.setSelectOptions(this.label);
          this.$emit("input", this.label);
          return 0;
        }
        //不读缓存
      } else {
        if (this.multiple === true) {
          //去掉[__ob__: Observer]
          this.$emit("input", Object.assign([], this.label));
        } else {
          this.$emit("input", this.label);
        }
      }
    },
    showSelectOptions: function showSelectOptions() {
      if (this.multiple === true) {
        if (this.getMutSelectOptions.length === 0) {
          //空数组才会查询全部
          this.prop_mutSelList = [];
        } else {
          this.prop_mutSelList = this.getMutSelectOptions;
        }
        //多选下拉框必须是数组
        this.label = this.prop_mutSelList;
      } else {
        this.prop_selopList = this.getSelectOptions;
        this.label = this.prop_selopList;
      }
      this.$emit("input", this.label);
    }
  })
};